// src/Dashboard.js
import React, { useEffect, useState } from "react";
import { apiFetch } from "./api";
import ClientDetails from "./ClientDetails";

export default function Dashboard() {
  const [clients, setClients] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    apiFetch("/clients").then(data => setClients(data.clients || []));
  }, []);

  return (
    <div className="dashboard">
      <h2>Active Clients</h2>
      <table>
        <thead>
          <tr>
            <th>Hostname</th>
            <th>Platform</th>
            <th>Last Seen</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {clients.map(client => (
            <tr key={client.id}>
              <td>{client.hostname}</td>
              <td>{client.platform}</td>
              <td>{client.last_seen}</td>
              <td>
                <button onClick={() => setSelected(client)}>Manage</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {selected && (
        <ClientDetails client={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
}
